import { VacancyFilters } from "@/lib/contexts/Vacancy/types";

type VacancyListParams = {
  city?: string[];
  clientId?: string;
  country?: string[];
  department?: string[];
  descending?: boolean | null;
  field?: string[];
  orderBy?: string | null;
  page?: number;
  pageSize?: number;
  search?: string;
  includeUnpublished?: boolean;
  channels?: string[];
  publicationChannels?: string[];
  publicationIds?: string[];
  company?: string[];
  district?: string[];
  segmentId?: string;
};

export const vacancyQueryKeys = {
  all: ["vacancies"] as const,
  lists: () => [...vacancyQueryKeys.all, "list"] as const,
  list: (params: VacancyListParams) =>
    [
      ...vacancyQueryKeys.lists(),
      params.city,
      params.clientId,
      params.country,
      params.department,
      params.descending,
      params.field,
      params.orderBy,
      params.page,
      params.pageSize,
      params.search,
      params.includeUnpublished,
      params.channels,
      params.publicationChannels,
      params.publicationIds,
      params.company,
      params.district,
      params.segmentId,
    ] as const,
  details: () => [...vacancyQueryKeys.all, "detail"] as const,
  detail: (vacancyId: string, clientId?: string) =>
    [...vacancyQueryKeys.details(), vacancyId, clientId] as const,
  filters: () => [...vacancyQueryKeys.all, "filters"] as const,
  filter: (clientId?: string, search?: string, includeUnpublished?: boolean) =>
    [...vacancyQueryKeys.filters(), clientId, search, includeUnpublished] as const,
  descriptions: () => [...vacancyQueryKeys.all, "descriptions"] as const,
  description: (groupNames: string[], clientId?: string) =>
    [...vacancyQueryKeys.descriptions(), groupNames, clientId] as const,
  counts: () => [...vacancyQueryKeys.all, "count"] as const,
  countByFilter: (filter: VacancyFilters, search?: string, includeUnpublished?: boolean) =>
    [...vacancyQueryKeys.counts(), "byFilter", filter, search, includeUnpublished] as const,
  countByRule: (clientId?: string, rule?: unknown) =>
    [...vacancyQueryKeys.counts(), "byRule", clientId, rule] as const,
  countBySegment: (segmentId?: string, includeUnpublished?: boolean) =>
    [...vacancyQueryKeys.counts(), "bySegment", segmentId, includeUnpublished] as const,
  history: (vacancyId: string, from: Date, to?: Date, pageSize?: number) =>
    [
      ...vacancyQueryKeys.all,
      "history",
      vacancyId,
      from.toISOString(),
      to?.toISOString(),
      pageSize,
    ] as const,
};
